export default "__VITE_ASSET__ByzlHE43__"